<template>
  <button-dialog-container
    btn-icon="mdi-plus"
    :is-rounded="false"
    :is-fab="true"
    :is-small="true"
    :is-button-disabled="disableAdd"
    :is-valid-disabled="disableValidation"
    @ok-pushed="addSchedule"
  >
    <schedule-card
      :new-schedule="true"
      :schedule="schedule"
      class="pt-6"
      :disable-validation.sync="disableValidation"
    />
    <file-explorer
      :dir="dirOpen"
      :filter="['.zip']"
      :reset="reset"
      @item-selected="itemSelected"
    />
    <dialog-duplicate-schedule
      :dialog="openDialogDuplicate"
      :multiple="multiple"
      :project-scheduled="projectScheduled"
      @yes-pushed="yesAddSchedule"
      @no-pushed="noAddSchedule"
      @cancel-pushed="cancelPushed"
    />
  </button-dialog-container>
</template>

<script>
// Components
import dialogDuplicateSchedule from "../Dialog/DialogDuplicateSchedule";
import buttonDialogContainer from "../Common/ButtonDialogContainer";
import scheduleCard from "../Common/ScheduleCard";
import fileExplorer from "../Common/FileExplorer";

// Controllers
import { Schedule } from "../MainObjects/Schedule";

// Connectors
import { ScheduleConnector } from "../Database/ScheduleConnector";

// TODO: Check why there is 2 imports of MainObjects Schedule
const scheduleModule = require("../MainObjects/Schedule");

export default {
  components: {
    dialogDuplicateSchedule,
    buttonDialogContainer,
    scheduleCard,
    fileExplorer,
  },
  props: {
    disableAdd: {
      type: Boolean,
      default: false,
    },
    playersSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dirOpen: this.$store.state.config.dirs.root + "mediacenter/" + this.$store.state.user.socId,
      multiple: false,
      openDialogDuplicate: false,
      scheduleConnector: new ScheduleConnector(this.$store.state.user),
      schedule: {},
      disableValidation: false,
      scheduleList: [],
      projectScheduled: "",
      listScheduleId: [],
      scheduleListDuplicate: [],
      checkboxYes: false,
      checkboxNo: false,
      reset: false,
    };
  },
  mounted() {
    this.schedule = this.createEmptySchedule("");

    // If dir limited for user we use this root path
    if (this.$store.state.user.dir != "") {
      this.dirOpen = this.$store.state.user.dir;
    }
  },
  methods: {
    addSchedule() {
      if (this.schedule.project == undefined) {
        return;
      }
      this.schedule.project.forEach((project) => {
        this.scheduleList.push(
          new Schedule(
            project,
            this.schedule.days,
            this.schedule.permanent,
            0,
            this.schedule.dateFrom,
            this.schedule.timeFrom,
            this.schedule.dateTo,
            this.schedule.timeTo,
            this.schedule.loop_limit,
            this.schedule.loop_duration
          )
        );
      });

      // TODO: Check if work correctly
      this.checkDuplicate();
      this.reset = false;
    },
    checkDuplicate() {
      const regex = new RegExp("\\\\", "g");
      if (this.scheduleList.length > 0) {
        // TODO: MAKE A FUNCTION REEUSE IN MULTIPLE PLACES
        const players = this.playersSelected.map((player) => {
          return player.plyrID;
        });

        this.scheduleConnector
          .checkDuplicateSchedule(players, this.scheduleList[0].projectData.path.replace(regex, "/"))
          .then((response) => {
            // TODO: VOIR SI UTILISER DATA NORMAL ? PAS JUSTE UTILISER LES PARAMS DE CHAQUE FONCTIONS
            this.listScheduleId = response;

            if (this.listScheduleId.length) {
              this.projectScheduled = this.scheduleList[0].projectData.path.replace(regex, "/");
              this.projectScheduled = this.projectScheduled.split("/").pop().replace(/.zip$/, "");
              if (!this.checkboxYes && !this.checkboxNo) {
                this.openDialogDuplicate = true;
              } else if (this.checkboxYes && !this.checkboxNo) {
                this.yesAddSchedule();
              } else if (this.checkboxNo && !this.checkboxYes) {
                this.noAddSchedule();
              }
            } else {
              this.$emit("add-schedule", this.scheduleList[0]);
              this.openDialogDuplicate = false;
              this.scheduleList.splice(0, 1);
              // TODO: AWAIT AVANT ??? RECURDIF  ???? POURQUOI ??? VA MOURIR
              this.checkDuplicate();
            }
          });
      } else {
        return true;
      }
    },
    yesAddSchedule(checkbox) {
      this.checkboxYes = checkbox;
      this.$emit("add-schedule", this.scheduleList[0]);
      this.scheduleList.splice(0, 1);
      this.openDialogDuplicate = false;
      // USELESS ????
      //await this.checkDuplicate();
    },
    noAddSchedule(checkbox) {
      const listGroup = [];
      this.checkboxNo = checkbox;
      this.playersselected.forEach((player) => {
        for (let i = 0; i < this.listScheduleId.length; i++) {
          listGroup.push({
            id_sched: this.listScheduleId[i].sched_id,
            plyr_id: player.plyrID,
          });
        }
      });

      this.scheduleConnector.deleteScheduleForPlayer(listGroup).then(() => {
        this.yesAddSchedule();
      });
    },
    itemSelected(val) {
      this.schedule.project = val;
    },
    createEmptySchedule() {
      return scheduleModule.CreateEmptySchedule();
    },
    recoverScheduleId() {
      const tempo = [];
      this.listScheduleId.forEach((id) => {
        tempo.push(id.sched_id);
      });

      return tempo;
    },
    cancelPushed() {
      this.scheduleList = [];
      this.openDialogDuplicate = false;
    },
  },
};
</script>

<style></style>
